export default __webpack_public_path__ + "static/media/fenestrapro_linc.30673e1b.svg";